import React, { useEffect, useState } from 'react'
import Plot from 'react-plotly.js';
import styles from './MileageAnalysisTab_bus.module.css';
import { Info } from 'lucide-react'
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import { useVehicleData } from './context';
import { OverlayTrigger, Popover, Tooltip } from 'react-bootstrap';

// import CustomPopover from './Popover';

function ModalBarChart({ data, selectedVehicleData, globalFilter, barChartInfo, customFilter }) {
    const { GlobalData } = useVehicleData();
    const { label } = data
    const { isLoading, error, sendReq: fetchData } = useHttp();
    const { firstVinNo, secondVinNo } = selectedVehicleData
    const { barName, vehicleType } = barChartInfo

    const [graphData, setGraphData] = useState([])
    const [benchmark, setBenchMark] = useState({
        currentValue: "",
        stdValue: ""
    })


useEffect(() => {

    let ApiUrl = "";

    // Determine the API for the chart data
    if (barName === "vehicleSpeedDistribution") {
        ApiUrl = vehicleType === "primary" ? "mileage_analysis_vehicle_speed_distribution_graph" :
            vehicleType === "best" ? "mileage_analysis_vehicle_speed_distribution_graph_best_vehicle" :
            vehicleType === "secondary" ? "mileage_analysis_vehicle_speed_distribution_graph" :
            vehicleType === "National" ? "mileage_analysis_national_vehicle_speed_distribution_graph" :
            vehicleType === "Depo" ? "mileage_analysis_depo_vehicle_speed_distribution_graph" : "";
    } else if (barName === "accPedalPosition") {
        ApiUrl = vehicleType === "primary" ? "mileage_analysis_accelaration_pedal_graph" :
            vehicleType === "best" ? "mileage_analysis_accelaration_pedal_graph_best_vehicle" :
            vehicleType === "secondary" ? "mileage_analysis_accelaration_pedal_graph" :
            vehicleType === "National" ? "mileage_analysis_national_accelarator_pedal_graph" :
            vehicleType === "Depo" ? "mileage_analysis_depo_accelarator_pedal_graph" : "";
    } else if (barName === "RPM") {
        ApiUrl = vehicleType === "primary" ? "mileage_analysis_rpm_graph" :
            vehicleType === "best" ? "mileage_analysis_rpm_graph_best_vehicle" :
            vehicleType === "secondary" ? "mileage_analysis_rpm_graph" :
            vehicleType === "National" ? "mileage_analysis_national_rpm_graph" :
            vehicleType === "Depo" ? "mileage_analysis_depo_rpm_graph" : "";
    }

    let vinNo =
        vehicleType === "primary" ? [firstVinNo?.vehicleId] :
        vehicleType === "best" ? [firstVinNo?.vehicleId] :
        vehicleType === "secondary" ? [secondVinNo?.vehicleId] :
        vehicleType === "National" ? [GlobalData?.nationalVehicleId] :
        vehicleType === "Depo" ? [GlobalData?.bestDepoVehicleId] : [];

    if (!ApiUrl) return;

    // ⭐ FETCH BENCHMARK FIRST (object response)
    fetchData(
        {
            url: API_URL_MAIN + "mileage_analysis/route_benchmark",
            body: {
                filterdata: {
                    VIN_NUM: vinNo,
                    BAR_NAME: barName
                }
            }
        },
        (benchmarkRes) => {

            console.log("🔵 Benchmark raw:", benchmarkRes);

            let stdValueFromApi = 0;

            // ⭐ Correct mapping based on your response object
            if (barName === "vehicleSpeedDistribution") {
                stdValueFromApi =
                    Number(benchmarkRes?.percentageTimeSpentInSpeed_30_50) || 0;
            }

            if (barName === "accPedalPosition") {
                stdValueFromApi =
                    Number(benchmarkRes?.percentageTimeSpentInAcc_pedal_position_1_20_40) || 0;
            }

            if (barName === "RPM") {
                stdValueFromApi =
                    Number(benchmarkRes?.percentageTimeSpentInMotorspeed_1000_2000) || 0;
            }
            
        

            setBenchMark(prev => ({ ...prev, stdValue: stdValueFromApi }));

            // Now fetch chart data EXACTLY same as before
            let filterData = vehicleType === "secondary" ? customFilter : globalFilter;

            fetchData(
                {
                    url: API_URL_MAIN + `mileage_analysis/${ApiUrl}`,
                    body: {
                        filterdata: {
                            ...filterData,
                            VIN_NUM: vinNo
                        }
                    }
                },
                (res) => {

                    const resData = res[0];
                    let barData, currentValue = 0;

                    // 🚫 I DON'T TOUCH ANY OF YOUR EXISTING LOGIC BELOW
                    // --------------------------------------------------

                    if (barName === "vehicleSpeedDistribution") {
                        barData = [
                            { range: '0-20', value: Number(resData?.Vehicle_Speed_Distribution_0_20?.value) || 0 },
                            { range: '20-30', value: Number(resData?.Vehicle_Speed_Distribution_20_30?.value) || 0 },
                            { range: '30-50', value: Number(resData?.Vehicle_Speed_Distribution_30_50?.value) || 0, target: stdValueFromApi },
                            { range: '50-60', value: Number(resData?.Vehicle_Speed_Distribution_50_60?.value) || 0 },
                            { range: '60+', value: Number(resData?.["Vehicle_Speed_Distribution_60+"]?.value) || 0 }
                        ];
                        currentValue = Number(resData?.Vehicle_Speed_Distribution_30_50?.value);
                    }

                    if (barName === "accPedalPosition") {
                        barData = [
                            { range: '0-20', value: resData?.["Accelarator Pedal_0_20"]?.value || 0 },
                            { range: '20-40', value: resData?.["Accelarator Pedal_20_40"]?.value || 0, target: stdValueFromApi },
                            { range: '40-60', value: resData?.["Accelarator Pedal_40_60"]?.value || 0 },
                            { range: '60+', value: resData?.["Accelarator Pedal_60+"]?.value || 0 }
                        ];
                        currentValue = Number(resData?.["Accelarator Pedal_20_40"]?.value);
                    }

                    if (barName === "RPM") {
                        barData = [
                            { range: '0-1000', value: resData?.["RPM_0_1000"]?.value || 0 },
                            { range: '1000-2000', value: resData?.["RPM_1000_2000"]?.value || 0, target: stdValueFromApi },
                            { range: '2000-3000', value: resData?.["RPM_2000_3000"]?.value || 0 },
                            { range: '3000-4000', value: resData?.["RPM_3000_4000"]?.value || 0 },
                            { range: '4000+', value: resData?.["RPM_4000_plus"]?.value || 0 }
                        ];
                        currentValue = Number(resData?.["RPM_1000_2000"]?.value);
                    }

                    setGraphData(barData);
                    setBenchMark(prev => ({ ...prev, currentValue }));
                }
            );
        }
    );

}, [globalFilter, barChartInfo, customFilter]);




    const [tooltipData, setTooltipData] = useState({
        relevant: 0,
        zeroValue: 0
    })


    function handlePopoverOpen() {
        setTooltipData({
            relevant: 0,
            zeroValue: 0
        })

        let ApiUrl = "";

        if (barName === "vehicleSpeedDistribution") {
            ApiUrl = vehicleType === "primary" ? "mileage_analysis_vehicle_speed_distribution_custom" :
                vehicleType === "best" ? "mileage_analysis_vehicle_speed_distribution_best" :
                    vehicleType === "secondary" ? "mileage_analysis_vehicle_speed_distribution_custom" :
                        vehicleType === "National" ? "mileage_analysis_national_vehicle_speed" :
                            vehicleType == "Depo" ? "mileage_analysis_depo_vehicle_speed" : ""


        } else if (barName === "accPedalPosition") {

            ApiUrl = vehicleType === "primary" ? "mileage_analysis_accelaration_pedal_custom" :
                vehicleType === "best" ? "mileage_analysis_accelaration_pedal_best" :
                    vehicleType === "secondary" ? "mileage_analysis_accelaration_pedal_custom" :
                        vehicleType === "National" ? "mileage_analysis_national_accelarator_pedal" :
                            vehicleType == "Depo" ? "mileage_analysis_depo_accelarator_pedal" : ""

        } else if (barName === "RPM") {

            ApiUrl = vehicleType === "primary" ? "mileage_analysis_rpm_Relevant_custom" :
                vehicleType === "best" ? "mileage_analysis_rpm_Relevant_best" :
                    vehicleType === "secondary" ? "mileage_analysis_rpm_Relevant_custom" :
                        vehicleType === "National" ? "mileage_analysis_national_rpm_Relevant" :
                            vehicleType == "Depo" ? "mileage_analysis_depo_rpm_Relevant" : ""


        } else {
            ApiUrl = "";
        }

        let filterData = vehicleType === "secondary" ? customFilter : globalFilter
        let vinNo = []
        if (ApiUrl) {
            vinNo = vehicleType === "primary" ? [firstVinNo?.vehicleId] :
                vehicleType === "best" ? [firstVinNo?.vehicleId] :
                    vehicleType === "secondary" ? [secondVinNo?.vehicleId] :
                        vehicleType === "National" ? [GlobalData?.nationalVehicleId] :
                            vehicleType == "Depo" ? [GlobalData?.bestDepoVehicleId] : []

        }

        fetchData(
            {
                url: API_URL_MAIN + `mileage_analysis/${ApiUrl}`,
                body: {
                    filterdata: {
                        ...filterData,
                        "VIN_NUM": vinNo,
                    }
                }
            },
            (res) => {
                let data = res[0]
                setTooltipData(prev => ({
                    ...prev,
                    relevant: data?.relevantValue?.value?.toFixed(2),
                    zeroValue: 0

                }))
            }
        );
    }


    const renderPopover = (
        <Popover
            className={styles.custom_popover_width}
        >
            <Popover.Body>
                <div className="container-fluid p-0">
                    <div className="row" style={{ height: '40px' }}>

                        {/* Left Section - 4 columns */}
                        <div className="col-5 pe-0 ps-2">
                            <small style={{ color: "#0d3f70" }}>{tooltipData?.relevant}%</small><br />
                            <span className="fw-6" style={{ fontSize: "10px" }}>{label} Relevant</span>
                        </div>

                        {/* Divider - 2 columns */}
                        <div className="col-1 d-flex align-items-center justify-content-center" style={{ height: '100%' }}>
                            <div
                                style={{
                                    width: '1.3px',
                                    height: '60%',
                                    backgroundColor: '#cddaea',
                                }}
                            ></div>
                        </div>

                        {/* Right Section - 4 columns */}
                        <div className="col-5 px-0">
                            <small style={{ color: "#0d3f70" }}>{tooltipData?.zeroValue}%</small> <br />
                            <span style={{ fontSize: "10px" }}>{label} 0</span>
                        </div>

                    </div>
                </div>
            </Popover.Body>
        </Popover>
    );




    return (
        <div>
            <div id="modalBarChart_MSbus" className="modal fade" role="dialog">
                <div className="modal-dialog modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title text-capitalize">{label}</h5>
                            <button type="button" className="close" data-dismiss="modal">
                                &times;
                            </button>
                        </div>
                        <div className="modal-body p-0" style={{ overflowY: "scroll", height: "380px", }}>
                            <div className="row mb-3 col-12" style={{ margin: '2px -5px 0 -5px', marginLeft: 'auto', marginRight: 'auto' }}> {/* Reduced top margin from 5px to 2px and constrained width */}
                                <div className="col-6" style={{ padding: '0 5px' }}>
                                    <div className={styles.summaryCard}>
                                        <div className={styles.summaryCardLabel} style={{
                                            fontSize: '10px',
                                            lineHeight: '1.2',
                                            minHeight: '32px',
                                            display: 'flex',
                                            alignItems: 'center'
                                        }}>
                                            Actual {label} Contribution
                                        </div>
                                        <div className="d-flex align-items-center justify-content-center">
                                            <span className='fw-bolder' style={{ fontSize: '14px', color: benchmark.currentValue >= benchmark.stdValue ? '#00b050' : '#c91104' }}>
                                                {Number(benchmark?.currentValue)?.toFixed(2)}%
                                            </span>
                                            <span style={{ fontSize: '14px', color: '#d9a404' }}>
                                                {benchmark.currentValue >= benchmark.stdValue ? '▲' : '▼'}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-6" style={{ padding: '0 5px' }}>
                                    <div className={styles.summaryCard}>
                                        <div className={styles.summaryCardLabel} style={{
                                            fontSize: '10px',
                                            lineHeight: '1.2',
                                            minHeight: '32px',
                                            display: 'flex',
                                            alignItems: 'center'
                                        }}>
                                            Potential {label} Contribution Following Benchmark
                                        </div>
                                        <div className="d-flex align-items-center justify-content-center">
                                            <span className={styles.bestValueText} style={{ fontSize: '14px' }}>
                                                {Number(benchmark?.stdValue)?.toFixed(2)}%
                                            </span>
                                            <span style={{ fontSize: '14px', color: '#d9a404' }}> ▲</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="position-relative">
                                <div className="d-flex justify-content-end px-3 mb-1">
                                    <span >
                                        <OverlayTrigger
                                            trigger="click"
                                            placement="bottom-end"
                                            overlay={renderPopover}
                                            onEnter={handlePopoverOpen}
                                            rootClose
                                        >
                                            <Info
                                                size={16}
                                                style={{ color: '#83a4cf', cursor: 'pointer' }}
                                            />
                                        </OverlayTrigger>
                                    </span>
                                </div>
                                <div className='d-flex justify-content-center'>
                                    {
                                        graphData?.length > 0 ?
                                            <CustomPlotlyBarChart data={graphData} benchmark={benchmark} />
                                            : <></>
                                    }
                                </div>
                                <div className="small text-muted mb-4 mt-0">
                                    Speed 0 and Speed NA are non-actionable buckets, hence not represented in the graph
                                </div>
                            </div>
                            <div className="modal-footer p-2">
                                <button type="button" className="btn ms_btn btn-default MS_button" data-dismiss="modal" >
                                    CLOSE
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </div>
    )
}

export default ModalBarChart




const CustomPlotlyBarChart = ({ data, benchmark }) => {
    const xLabels = data.map(d => d.range);
    const yValues = data.map(d => d.value);

    const targetIndex = data.findIndex(d => d.target !== undefined && d.target !== null);
    const targetBar = data[targetIndex];

    const barColors = data.map((d, i) => (i === targetIndex ? (benchmark.currentValue >= benchmark.stdValue ? '#00b050' : '#c91104') : '#d9d9d9'));

    const annotations = [];
    const shapes = [];

    if (targetBar) {
        const xPos = targetBar.range;
        const yPos = targetBar.value;
        const isTargetBelow = targetBar.value > targetBar.target;
        const triangleColor = isTargetBelow ? '#00b050' : '#ffc000';
        const triangleDirection = !isTargetBelow ? 'up' : 'down';

        const trianglePath =
            triangleDirection === 'up'
                ? 'M 0 10 L 5 0 L 10 10 Z'
                : 'M 0 0 L 5 10 L 10 0 Z';

        shapes.push({
            type: 'path',
            path: trianglePath,
            xref: 'x',
            yref: 'y',
            xsizemode: 'pixel',
            ysizemode: 'pixel',
            xanchor: xPos,
            yanchor: yPos + 5,
            xshift: -5,
            line: { width: 0 },
            fillcolor: triangleColor,
        });

        shapes.push({
            type: 'line',
            x0: xPos,
            x1: xPos,
            y0: targetBar.target,
            y1: targetBar.target,
            line: {
                color: '#000',
                width: 1,
                dash: 'dot',
            },
        });

        const labelMargin = 14;

        annotations.push({
            x: xPos,
            y: yPos + labelMargin + 6,
            text: `${targetBar.target.toFixed(2)}%`,
            showarrow: false,
            font: { color: '#002060', size: 10, family: 'Arial', weight: 'bold' },
            yshift: 0,
        });

        annotations.push({
            x: xPos,
            y: yPos + labelMargin,
            text: `${targetBar.value.toFixed(2)}%`,
            showarrow: false,
            font: { color: triangleColor, size: 10, family: 'Arial', weight: 'bold' },
            yshift: 0,
        });
    }

    // Add labels for all non-target bars
    data.forEach((d, index) => {
        if (index !== targetIndex) {
            annotations.push({
                x: d.range,
                y: d.value + 14,
                text: `${d.value.toFixed(2)}%`,
                showarrow: false,
                font: {
                    color: '#595959',
                    size: 10,
                    family: 'Arial',
                },
                yshift: 0,
            });
        }
    });

    return (
        <Plot
            data={[
                {
                    x: xLabels,
                    y: yValues,
                    type: 'bar',
                    marker: {
                        color: barColors,
                    },
                    hovertemplate: '%{y:.2f}%',
                },
            ]}
            layout={{
                height: 230,
                width: 420,
                margin: { t: 10, r: 20, l: 40, b: 20 },
                xaxis: {
                    title: '',
                    tickfont: { size: 10 },
                },
                yaxis: {
                    title: {
                        text: 'Duration %',
                        font: { size: 10 },
                        standoff: 10,
                    },
                    range: [0, 100],
                    ticksuffix: '%',
                    tickfont: { size: 10 },
                    showline: true,
                    linecolor: '#000',
                    linewidth: 1,
                },
                annotations: annotations,
                shapes: shapes,
                bargap: 0.4,
                plot_bgcolor: '#fff',
                paper_bgcolor: '#fff',
                showlegend: false,
            }}
            config={{
                responsive: true,
                displayModeBar: false,
                staticPlot: true,
            }}
        />
    );
};








